export enum BannerAnnouncementType {
  INFO = 'info',
  SUCCESS = 'success',
  CRITICAL = 'critical',
  BLACK_FRIDAY = 'black-friday',
}
